<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="3" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark>mdi-arrow-left</v-icon>
          </v-btn>
          Edit VIP Level
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.name"
                outlined
                label="Name"
                prepend-inner-icon="mdi-format-letter-case"
              />
            </v-col>

            <v-col sm="4">
              <v-text-field
                v-model="form.level"
                outlined
                label="Level"
                type="number"
                prepend-inner-icon="mdi-stairs-up"
              />
            </v-col>

            <v-col sm="4">
              <v-text-field
                v-model="form.cost_in_coins"
                outlined
                label="Cost in Coins"
                type="number"
                prepend-inner-icon="mdi-cash-multiple"
              />
            </v-col>

            <v-col sm="4">
              <v-text-field
                v-model="form.duration_days"
                outlined
                type="number"
                label="Duration Days"
                prepend-inner-icon="mdi-calendar-range"
              />
            </v-col>

            <v-col sm="8">
              <v-textarea
                v-model="form.description"
                outlined
                label="Description"
                prepend-inner-icon="mdi-text"
              />
            </v-col>

            <!-- Badge Image Upload -->
            <v-col sm="4">
              <label class="v-label theme--light" style="font-size:12px">Badge Image (animal icon shown in app)</label>
              <input
                type="file"
                ref="badgeImageInput"
                accept="image/*"
                style="display:block; margin-top:8px"
                @change="onBadgeImageChange"
              />
              <div v-if="badgeImagePreview" class="mt-3">
                <label style="font-size:12px">Preview</label><br />
                <img :src="badgeImagePreview" style="height:80px;width:80px;object-fit:cover;border-radius:50%;border:2px solid #FFD700" />
              </div>
              <div v-else-if="form.badge_image" class="mt-3">
                <label style="font-size:12px">Current Image</label><br />
                <img :src="`${mediaUrl}${form.badge_image}`" style="height:80px;width:80px;object-fit:cover;border-radius:50%;border:2px solid #FFD700" />
              </div>
            </v-col>

            <!-- MULTIPLE PRIVILEGES -->
            <v-col sm="4">
              <v-autocomplete
                outlined
                v-model="form.privileges"
                :items="privilegesItems"
                item-text="title"
                item-value="id"
                label="Privileges *"
                prepend-inner-icon="mdi-account-tie-outline"
                multiple
                clearable
              />
            </v-col>

            <v-col sm="4">
              <v-switch
                class="mt-0 ml-5"
                v-model="form.is_active"
                inset
                :label="`Is Active: ${form.is_active ? 'YES' : 'NO'}`"
              />
            </v-col>
          </v-row>

          <v-divider class="my-5" />

          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Update VIP Level
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";

export default {
  name: "VipLevelIdPage",
  data() {
    return {
      form: {
        id: null,
        name: "",
        level: null,
        cost_in_coins: null,
        duration_days: null,
        description: "",
        is_active: false,
        privileges: [], // array of IDs
        badge_image: null,
      },
      privilegesItems: [],
      old_json: null,
      isLoading: false,
      badgeImageFile: null,
      badgeImagePreview: null,
    };
  },
  mounted() {
    this.getData();
    this.getPrivileges();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      try {
        let encryptedId = this.$route.params.vipLevelId;
        let response = await axios.get(`/vip_levels/${encryptedId}`);

        // fill form
        this.form = response.data.data;
        // privileges as array of IDs
        this.form.privileges = response.data.data.privileges.map(
          (p) => p.id
        );
        this.old_json = response.data.data;

        console.log("Form Data:", this.form.privileges);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        this.isLoading = false;
      }
    },

    async getPrivileges() {
      try {
        let response = await axios.get(`/vip_privileges`);
        this.privilegesItems = response.data.data;
      } catch (error) {
        console.error("Error fetching privileges:", error);
      }
    },

    async save() {
      this.isLoading = true;
      try {
        if (this.badgeImageFile) {
          // Use FormData so the file is sent as multipart
          const formData = new FormData();
          formData.append("name", this.form.name);
          formData.append("level", this.form.level);
          if (this.form.cost_in_coins != null) formData.append("cost_in_coins", this.form.cost_in_coins);
          if (this.form.duration_days != null) formData.append("duration_days", this.form.duration_days);
          if (this.form.description) formData.append("description", this.form.description);
          formData.append("is_active", this.form.is_active ? 1 : 0);
          (this.form.privileges || []).forEach(id => formData.append("privileges[]", id));
          formData.append("badge_image", this.badgeImageFile);
          formData.append("_method", "PATCH");

          await axios.post(
            `/vip_levels/${this.$route.params.vipLevelId}`,
            formData,
            { headers: { "Content-Type": "multipart/form-data" } }
          );
        } else {
          await axios.patch(
            `/vip_levels/${this.$route.params.vipLevelId}`,
            this.form
          );
        }

        await this.saveUserTimestamp(this.old_json, this.form);
        this.$router.push("/vip-levels");
      } catch (e) {
        console.error("Save error:", e);
      } finally {
        this.isLoading = false;
      }
    },

    onBadgeImageChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.badgeImageFile = file;
        this.badgeImagePreview = URL.createObjectURL(file);
      }
    },

    async saveUserTimestamp(oldData, newData) {
      try {
        let form = {
          from_path: `/vip_levels/${this.form.id}`,
          from_name: "VipLevelIdPage",
          user_id: this.user.id,
          old_json: JSON.stringify(oldData),
          new_json: JSON.stringify(newData),
        };
        await axios.post(`/user_timestamps`, form);
      } catch (error) {
        console.log("Timestamp error:", error);
      }
    },
  },
};
</script>
